import LLGlobeTrotter from '@/locales/GlobeTrotter/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLTravel from '@/locales/Travel/fr';
import LLTune from '@/locales/Tune/fr';
import LLFuture from '@/locales/Future/fr';
import LLArtySG from '@/locales/ArtySG/fr';
import LLArtyCarpenters from '@/locales/ArtyCarpenters/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLEntrepreneurs from '@/locales/Entrepreneurs/fr';
import LLRugby from '@/locales/Rugby/fr';
import LLEssential from '@/locales/Essential/fr';
import LLWayISeeIt from '@/locales/WayISeeIt/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        Edito: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoUK: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        Essential: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        WayISeeIt: {
            segment: 'billet-humeur',
            title: 'Billet d‘humeur',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Tendances',
        },
        GlobeTrotter: {
            segment: 'planete-insolite',
            title: 'Planète insolite',
        },
        Travel: {
            segment: 'evasions-celestes',
            title: 'Évasions célestes',
        },
        Tune: {
            segment: 'entretien-barbara-hannigan',
            title: 'Barbara Hannigan, mentor passionné',
        },
        Rugby: {
            segment: 'terrain-favorable',
            title: 'Terrain favorable avec Jonny Wilkinson',
        },
        Future: {
            segment: 'nouvelles-formes-consommation',
            title: 'À l‘aube de nouvelles formes de consommation',
        },
        ArtyCarpenters: {
            segment: 'carpenters-workshop-gallery',
            title: 'Carpenters Workshop Gallery, une autre vision du design',
        },
        ArtySG: {
            segment: 'societe-generale-collection',
            title: 'La sculpture dans la collection Société Générale',
        },
        KeyReport: {
            segment: 'education-reinventee',
            title: 'L‘éducation réinventée',
        },
        Entrepreneurs: {
            segment: 'michel-feraud-president-provepharm-life-solutions',
            title: 'Michel Feraud, Président de Provepharm Life Solutions',
        },
        Legal: {
            segment: 'credits-informations-legales',
            title: 'Credits & informations légales',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    Essential: LLEssential,

    Edito: LLEdito,
    EditoMC: LLEdito,
    EditoCH: LLEdito,
    EditoLU: LLEdito,
    EditoUK: LLEdito,
    EditoFR: LLEdito,

    TrendingNow: LLTrendingNow,

    GlobeTrotter: LLGlobeTrotter,

    Travel: LLTravel,
    Tune: LLTune,

    Future: LLFuture,

    ArtySG: LLArtySG,
    ArtyCarpenters: LLArtyCarpenters,

    KeyReport: LLKeyReport,

    Entrepreneurs: LLEntrepreneurs,

    Rugby: LLRugby,

    WayISeeIt: LLWayISeeIt,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Voir le monde différemment avec <br />Société&nbsp;Générale Private&nbsp;Banking <br/>Automne 2019 #3',
        title: 'Barbara Hannigan, mentor passionné',
        artitle1title: 'Ils pensent le futur',
        artitle1content: 'La consommation à l‘heure de l‘e-commerce',
        artitle2title: 'Le grand dossier',
        artitle2content:  'Quand l‘éducation fait sa révolution numérique',
        artitle3title: 'Voyager différemment',
        artitle3content:  'Les ciels de Jeff Dai, Pierre Destribats, Théo Giacometti et Paul Zizka',
    },

    next: 'À suivre : ',

    welcome_message : 'FR - Welcome to Your Vue.js App',
    popular_links : 'FR - Popular Links',
    ecosystem : 'FR - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ',',
    counterUpDecimal: '.',
};
